/**
 * External dependencies
 */
import A11yDialog from 'a11y-dialog';

/**
 * Check if the given element is a child of the specified parent element.
 *
 * @param {HTMLElement} element The element to check.
 * @param {string} parentSelector The selector for the parent element.
 * @returns {boolean} True if the element is a child of the parent; otherwise, false.
 */
const isChildOf = (element, parentSelector) => {
	return element.closest(parentSelector) !== null;
};

const getTriggerButton = (element) => {
	if (element.tagName === 'SPAN') {
		const childLink = element.querySelector('a');
		if (childLink) {
			return childLink;
		}
		return element.closest('a');
	}

	return element;
};

/**
 * Initialize modal dialog functionality for the specified trigger buttons.
 *
 * This function selects all elements with the class 'dv-modal-trigger',
 * determines the modal type based on the button's parent, and binds
 * click events to show the appropriate modal dialog.
 */
const initModal = () => {
	const triggerButtons = document.querySelectorAll('.dv-modal-trigger');
	let redirectUrl;

	// Exit if no trigger buttons are found
	if (!triggerButtons.length) {
		return;
	}

	triggerButtons.forEach((triggerButton) => {
		let modalType;

		// Determine which type of modal to show
		const isRecaptchaModal = isChildOf(triggerButton, '.modal-with-recaptcha');
		const isFormModal = isChildOf(triggerButton, '.modal-with-form');
		const isSimpleModal = isChildOf(triggerButton, '.modal-simple');

		if (isSimpleModal) {
			modalType = 'dv-modal-simple';
		} else if (isRecaptchaModal) {
			modalType = 'dv-modal-with-recaptcha';
		} else if (isFormModal) {
			modalType = 'dv-modal-with-form';
		}

		// Proceed if a modal type is determined
		if (modalType) {
			const modalElement = document.querySelector(`#${modalType}`);

			if (!modalElement) {
				return;
			}

			const realButton = getTriggerButton(triggerButton);
			const dialog = new A11yDialog(modalElement);
			const modalRecaptcha = modalElement.querySelector('.g-recaptcha');
			const submitButton = modalElement.querySelector(
				'.dv-dialog-content__form__submit-button',
			);

			if (isRecaptchaModal && modalRecaptcha) {
				submitButton.setAttribute('disabled', true);
			}

			// Bind click event to trigger the modal dialog
			realButton.addEventListener('click', (e) => {
				e.preventDefault();
				redirectUrl = realButton.getAttribute('href');
				dialog.show();
			});
		}
	});

	const forms = document.querySelectorAll('.dv-dialog-form');
	// Bind submit event
	if (forms) {
		forms.forEach((form) => {
			form.addEventListener('submit', (e) => {
				e.preventDefault();
				window.open(redirectUrl, '_blank');
			});
		});
	}
};

export default initModal;
